<template>
  <div class="interviewer-schedule-page">
    <header class="topbar">
      <div>
        <div class="topTitle">{{ pageTitle }}</div>
      </div>
      <div class="topRight">
        <!-- <div class="pill">{{ statsSummary }}</div> -->
        <el-button v-if="!isMobile" size="small" native-type="button" v-has="'btn_add'" @click="showCreateForm">
          <span class="topActionPlus">+</span> 添加面试
        </el-button>
      </div>
    </header>

    <CommonFilterTableCard
      v-if="!isMobile"
      title="📋 面试安排"
      :items="allInterviews"
      :page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :columns="scheduleColumns"
      :loading="tableLoading"
      :use-server-pagination="true"
      :total="interviewTotal"
      :filter-schema="scheduleFilterSchema"
      :filter-values.sync="scheduleFilters"
      @page-change="fetchInterviews"
      @filter-change="onScheduleFilterChange"
    >
      <template #col-candidate="{ row }">
        <a href="javascript:void(0)" class="candidate-link" @click.prevent="goInterviewDetail(row)">
          {{ row.candidate_name || "—" }}
        </a>
      </template>

      <template #col-candidateEmail="{ row }">
        {{ row.candidate_email || "—" }}
      </template>

      <template #col-interviewerEmail="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.email) || "—" }}
      </template>

      <template #col-interviewTime="{ row }">
        {{ row.interview_time || "—" }}
      </template>

      <template #col-interviewerName="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.name) || "—" }}
      </template>

      <template #col-interviewerPhone="{ row }">
        {{ (row.interviewer_info && row.interviewer_info.phone) || "—" }}
      </template>

      <template #col-recruiterName="{ row }">
        {{ (row.recruiter_info && row.recruiter_info.name) || "—" }}
      </template>

      <template #col-recruiterPhone="{ row }">
        {{ (row.recruiter_info && row.recruiter_info.phone) || "—" }}
      </template>

      <template #col-resume="{ row }">
        <a
          href="javascript:void(0)"
          class="resume-download-link"
          :class="{ 'resume-download-link--non-pdf': isResumeListNonPdf(row) }"
          :title="resumeText(row)"
          @click.prevent="previewResumeFromList(row)"
        >
          {{ resumeText(row) }}
        </a>
      </template>

      <template #col-current_status="{ row }">
        <span
          :class="['status', getStatusMeta(row && row.current_status).cls]"
        >
          {{ getStatusMeta(row && row.current_status).text }}
        </span>
      </template>

      <template #col-actions="{ row }">
        <div class="row-actions" :class="{ 'row-actions-wide': !scheduleFilters || !scheduleFilters.status || scheduleFilters.status === 'all' }">
          <el-button
            v-if="Number(row.current_status) === 1 || Number(row.current_status) === 2"
            size="small"
            native-type="button"
            v-has="'btn_join'"
            class="btnLink primary small"
            @click="enterRoom(row)"
          >
            进入面试
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 0 || Number(row.current_status) === 1"
            size="small"
            native-type="button"
            v-has="'btn_edit'"
            class="btnLink small"
            @click="showEditForm(row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 0 || Number(row.current_status) === 1"
            v-has="'btn_delete'"
            size="small"
            native-type="button"
            class="btnLink danger small"
            @click="deleteInterview(row)"
          >
            删除
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 0 || Number(row.current_status) === 1"
            v-has="'btn_send'"
            size="small"
            native-type="button"
            class="btnLink small"
            :disabled="sendingNotification && String(sendingNotificationInterviewId) === String(row.id)"
            @click="sendNotification(row)"
          >
            {{
              sendingNotification && String(sendingNotificationInterviewId) === String(row.id)
                ? "发送中..."
                : "发送通知"
            }}
          </el-button>
          <el-button
           v-if="Number(row.current_status) === 3"
            v-has="'btn_assess'"
            size="small"
            native-type="button"
            class="btnLink primary small"
            @click="openEvalModal(row)"
          >
            面试评价
          </el-button>
          <el-button
            v-if="Number(row.current_status) === 3"
            v-has="'btn_remind'"
            size="small"
            native-type="button"
            class="btnLink small"
            @click="sendEvalReminder(row)"
          >
            评价提醒
          </el-button>
        </div>
      </template>
    </CommonFilterTableCard>

    <!-- 移动端：卡片视图 -->
    <div v-if="isMobile" class="schedule-mobile">
      <div class="schedule-mobile-filter">
        <el-form label-position="top" @submit.native.prevent>
          <div class="schedule-mobile-filter-grid">
            <el-form-item label="状态" style="margin-bottom: 0;">
              <el-select
                v-model="scheduleFilters.status"
                size="small"
                placeholder="请选择状态"
                @change="onScheduleFilterChange"
              >
                <el-option label="全部" value="all" />
                <el-option label="待通知" value="0" />
                <el-option label="待开始" value="1" />
                <el-option label="进行中" value="2" />
                <el-option label="待评价" value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="候选人姓名/电话" style="margin-bottom: 0;">
              <el-input
                v-model="scheduleFilters.candidate_param"
                size="small"
                placeholder="请输入"
                clearable
                @keyup.enter.native="onScheduleFilterChange"
                @clear="onScheduleFilterChange"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search schedule-mobile-candidate-search-icon"
                  title="搜索"
                  @click.stop="onScheduleFilterChange"
                />
              </el-input>
            </el-form-item>
            <el-form-item label="面试岗位" style="margin-bottom: 0;">
              <el-input
                v-model="scheduleFilters.position"
                size="small"
                placeholder="请输入"
                clearable
                @keyup.enter.native="onScheduleFilterChange"
                @clear="onScheduleFilterChange"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search schedule-mobile-candidate-search-icon"
                  title="搜索"
                  @click.stop="onScheduleFilterChange"
                />
              </el-input>
            </el-form-item>
            <el-form-item label="招聘HR/电话" style="margin-bottom: 0;">
              <el-input
                v-model="scheduleFilters.recruiter_param"
                size="small"
                placeholder="请输入"
                clearable
                @keyup.enter.native="onScheduleFilterChange"
                @clear="onScheduleFilterChange"
              >
                <i
                  slot="suffix"
                  class="el-input__icon el-icon-search schedule-mobile-candidate-search-icon"
                  title="搜索"
                  @click.stop="onScheduleFilterChange"
                />
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div
        ref="mobileCardList"
        class="schedule-card-list"
        @scroll.passive="handleMobileListScroll"
      >
        <MobileInterviewCard
          v-for="row in allInterviews"
          :key="row.id"
          :row="row"
          @enter="enterRoom"
          @assess="openEvalModal"
          @preview-resume="previewResumeFromList"
          @candidate-detail="goInterviewDetail"
        />

        <div v-if="!tableLoading && (!allInterviews || !allInterviews.length)" class="schedule-card-empty">
          暂无面试安排
        </div>
        <div
          v-if="!tableLoading && mobileLoadingMore"
          class="schedule-mobile-load-more"
        >
          正在加载更多...
        </div>
        <div
          v-else-if="!tableLoading && allInterviews && allInterviews.length && !mobileHasMore"
          class="schedule-mobile-load-more done"
        >
          已加载全部内容
        </div>
      </div>
    </div>
    
    <div v-if="isMobile && tableLoading" class="schedule-mobile-loading-mask">
      <el-skeleton :rows="3" animated />
    </div>

    <!-- 添加/编辑面试弹窗 -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content schedule-interview-modal hr-like-modal">
        <div class="modal-header">
          <h3>{{ modalTitle }}</h3>
          <button type="button" class="modal-close-btn" aria-label="关闭" @click="showModal = false">&times;</button>
        </div>
        <div v-if="modalMode === 'create'" class="modal-body">
          <label class="required-label">候选人姓名</label>
          <input v-model="form.candidate" maxlength="30" :class="{ 'field-error': createErrors.candidate }" type="text" placeholder="请输入" />
          <div v-if="createErrors.candidate" class="error-tip">{{ createErrors.candidate }}</div>
          <label class="required-label">候选人电话</label>
          <input v-model="form.phone" maxlength="11" :class="{ 'field-error': createErrors.phone }" type="tel" placeholder="请输入" />
          <div v-if="createErrors.phone" class="error-tip">{{ createErrors.phone }}</div>
          <label class="required-label">候选人邮箱</label>
          <input
            v-model="form.candidateEmail"
            maxlength="50"
            :class="{ 'field-error': createErrors.candidateEmail }"
            type="email"
            placeholder="请输入"
          />
          <div v-if="createErrors.candidateEmail" class="error-tip">{{ createErrors.candidateEmail }}</div>
          <label class="required-label">面试官姓名</label>
          <el-select
            v-model="form.interviewerId"
            filterable
            remote
            :remote-method="onInterviewerRemoteSearch"
            placeholder="请选择面试官"
            class="form-select"
            :class="{ 'field-error': createErrors.interviewerId }"
            :loading="interviewerLoading"
            @change="onInterviewerChange"
          >
            <el-option
              v-for="it in interviewerOptions"
              :key="it.userid"
              :label="`${it.name}（${it.work_no || '-'}）`"
              :value="it.userid"
            />
          </el-select>
          <div v-if="createErrors.interviewerId" class="error-tip">{{ createErrors.interviewerId }}</div>
          <label class="required-label">面试官电话</label>
          <input
            v-model="form.interviewerPhone"
            maxlength="11"
            :class="{ 'field-error': createErrors.interviewerPhone }"
            type="tel"
            placeholder="请选择面试官"
            disabled
          />
          <div v-if="createErrors.interviewerPhone" class="error-tip">{{ createErrors.interviewerPhone }}</div>
          <label class="required-label">面试官邮箱</label>
          <input
            v-model="form.interviewerEmail"
            maxlength="50"
            :class="{ 'field-error': createErrors.interviewerEmail }"
            type="email"
            placeholder="请选择面试官"
            disabled
          />
          <div v-if="createErrors.interviewerEmail" class="error-tip">{{ createErrors.interviewerEmail }}</div>
          <label class="required-label">面试时间</label>
          <div class="interview-time-row" :class="{ 'field-error': createErrors.timeRange }">
            <el-date-picker
              v-model="form.interviewDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="{ disabledDate: disableInterviewPastDate }"
              placeholder="选择日期"
              class="time-date"
            />
            <el-time-picker
              v-model="form.startTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              class="time-clock"
              @change="onStartTimeChange"
            />
            <span class="time-sep">-</span>
            <el-time-picker
              v-model="form.endTime"
              :picker-options="endTimePickerOptions"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              class="time-clock"
              :disabled="endTimeDisabled"
            />
          </div>
          <div v-if="createErrors.timeRange" class="error-tip">{{ createErrors.timeRange }}</div>
          <label class="required-label">职位</label>
          <input v-model="form.position" maxlength="30" :class="{ 'field-error': createErrors.position }" type="text" />
          <div v-if="createErrors.position" class="error-tip">{{ createErrors.position }}</div>
          <label class="required-label">简历文件</label>
          <div class="file-upload" :class="{ 'field-error': createErrors.resume }" @click="$refs.resumeInput && $refs.resumeInput.click()">
            <input
              ref="resumeInput"
              type="file"
              accept=".pdf,.doc,.docx"
              style="display: none"
              @change="onResumeChange"
            />
            <span class="file-name" :title="form.resumeFileName || ''" @click.stop="onResumeFileNameClick">
              {{ form.resumeFileName || "点击选择文件（PDF/Word）" }}
            </span>
            <el-button
              v-if="form.resume || form.resumeFileName || form.resumeFile"
              size="small"
              native-type="button"
              class="btnLink small file-remove-btn"
              title="删除附件"
              @click.stop="removeResumeAttachment"
            >
              <i class="el-icon-close"></i>
            </el-button>
          </div>
          <div v-if="createErrors.resume" class="error-tip">{{ createErrors.resume }}</div>
        </div>
        <div v-if="modalMode === 'edit'" class="modal-body">
          <label class="required-label">候选人姓名</label>
          <input v-model="form.candidate" :class="{ 'field-error': createErrors.candidate }" type="text" />
          <div v-if="createErrors.candidate" class="error-tip">{{ createErrors.candidate }}</div>
          <label class="required-label">候选人电话</label>
          <input v-model="form.phone" :class="{ 'field-error': createErrors.phone }" type="tel" />
          <div v-if="createErrors.phone" class="error-tip">{{ createErrors.phone }}</div>
          <label class="required-label">候选人邮箱</label>
          <input v-model="form.candidateEmail" :class="{ 'field-error': createErrors.candidateEmail }" type="email" />
          <div v-if="createErrors.candidateEmail" class="error-tip">{{ createErrors.candidateEmail }}</div>
          <label class="required-label">面试官姓名</label>
          <el-select
            v-model="form.interviewerId"
            filterable
            remote
            :remote-method="onInterviewerRemoteSearch"
            placeholder="请选择面试官"
            class="form-select"
            :class="{ 'field-error': createErrors.interviewerId }"
            :loading="interviewerLoading"
            @change="onInterviewerChange"
          >
            <el-option
              v-for="it in interviewerOptions"
              :key="it.userid"
              :label="`${it.name}（${it.work_no || '-'}）`"
              :value="it.userid"
            />
          </el-select>
          <div v-if="createErrors.interviewerId" class="error-tip">{{ createErrors.interviewerId }}</div>
          <label class="required-label">面试官电话</label>
          <input v-model="form.interviewerPhone" :class="{ 'field-error': createErrors.interviewerPhone }" type="tel" disabled />
          <div v-if="createErrors.interviewerPhone" class="error-tip">{{ createErrors.interviewerPhone }}</div>
          <label class="required-label">面试官邮箱</label>
          <input v-model="form.interviewerEmail" :class="{ 'field-error': createErrors.interviewerEmail }" type="email" disabled />
          <div v-if="createErrors.interviewerEmail" class="error-tip">{{ createErrors.interviewerEmail }}</div>
          <label class="required-label">面试时间</label>
          <div class="interview-time-row" :class="{ 'field-error': createErrors.timeRange }">
            <el-date-picker
              v-model="form.interviewDate"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="{ disabledDate: disableInterviewPastDate }"
              placeholder="选择日期"
              class="time-date"
            />
            <el-time-picker
              v-model="form.startTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              class="time-clock"
              @change="onStartTimeChange"
            />
            <span class="time-sep">-</span>
            <el-time-picker
              v-model="form.endTime"
              :picker-options="endTimePickerOptions"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              class="time-clock"
              :disabled="endTimeDisabled"
            />
          </div>
          <div v-if="createErrors.timeRange" class="error-tip">{{ createErrors.timeRange }}</div>
          <label class="required-label">职位</label>
          <input v-model="form.position" :class="{ 'field-error': createErrors.position }" type="text" />
          <div v-if="createErrors.position" class="error-tip">{{ createErrors.position }}</div>
          <label class="required-label">简历文件</label>
          <div class="file-upload" :class="{ 'field-error': createErrors.resume }" @click="$refs.resumeInput && $refs.resumeInput.click()">
            <input
              ref="resumeInput"
              type="file"
              accept=".pdf,.doc,.docx"
              style="display: none"
              @change="onResumeChange"
            />
            <span
              class="file-name"
              :title="form.resumeFileName || form.resume || ''"
              @click.stop.prevent="onResumeFileNameClick"
            >
              {{ form.resumeFileName || form.resume || "点击选择文件（PDF/Word）" }}
            </span>
            <el-button
              v-if="form.resume || form.resumeFileName || form.resumeFile"
              size="small"
              native-type="button"
              class="btnLink small file-remove-btn"
              title="删除附件"
              @click.stop="removeResumeAttachment"
            >
              <i class="el-icon-close"></i>
            </el-button>
          </div>
          <div v-if="createErrors.resume" class="error-tip">{{ createErrors.resume }}</div>
        </div>
        <div class="modal-actions">
          <el-button native-type="button" @click="showModal = false">取消</el-button>
          <el-button
            type="primary"
            native-type="button"
            v-has="modalMode === 'create' ? 'btn_add' : 'btn_edit'"
            :disabled="interviewSubmitting"
            @click="confirmModal"
          >
            {{ interviewSubmitting ? "提交中..." : "确认" }}
          </el-button>
        </div>
      </div>
    </div>

    <InterviewEvaluationModal
      :visible="showEvalModal"
      :scores="evalScores"
      :errors="evalErrors"
      :submitting="evalSubmitting"
      evaluation-stage="other"
      @cancel="closeEvalModal"
      @confirm="confirmEval"
      @update-score="onEvalScoreUpdate"
      @revalidate-field="revalidateEvalField"
    />

    <!-- 简历附件预览弹窗（参考面试复核列表预览效果） -->
    <div v-if="showResumePreviewModal" class="modal-overlay preview-modal" @click.self="closeResumePreviewModal">
      <div class="modal-content">
        <div class="preview-header">
          <h3>简历附件预览</h3>
        </div>
        <div class="preview-body">
          <div v-if="resumePreviewLoading" class="preview-loading">正在获取预览文件…</div>
          <VueOfficePdf
            v-if="!resumePreviewLoading && resumePreviewIframeSrc"
            :src="resumePreviewIframeSrc"
            class="preview-iframe"
          />
          <div v-else-if="!resumePreviewLoading" class="preview-loading">当前简历格式暂不支持预览</div>
        </div>
        <div class="preview-footer">
          <el-button native-type="button" @click="closeResumePreviewModal">关闭</el-button>
          <el-button
            type="primary"
            native-type="button"
            :disabled="resumePreviewLoading || !resumePreviewFileName"
            @click="downloadResumeByFileName(resumePreviewFileName, resumePreviewDisplayName)"
          >
            下载
          </el-button>
        </div>
      </div>
    </div>

    <div v-if="sendingNotification" class="send-loading-mask" aria-live="polite" aria-busy="true">
      <div class="send-loading-card">
        <span class="send-loading-spinner" />
        <span class="send-loading-text">发送中...</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  createInterview,
  listInterview,
  updateInterview,
  deleteInterview as deleteInterviewApi,
  sendInterviewEvaluationSms,
  sendInterviewNotification,
  submitEvaluation,
} from "@/api/modules/interview/interview";
import { listInterviewers } from "@/api/modules/users/user";
import { uploadCommonFile } from "@/api/commonUpload";
import { isEmail, isMobile11 } from "@/utils/validator";
import { get as commonGet } from "@/api/common/request";
import CommonFilterTableCard from "../components/CommonFilterTableCard.vue";
import MobileInterviewCard from "../components/MobileInterviewCard.vue";
import VueOfficePdf from "@vue-office/pdf";
import InterviewEvaluationModal from "../components/InterviewEvaluationModal.vue";



export default {
  name: "InterviewerSchedulePage",
  components: { CommonFilterTableCard, MobileInterviewCard, VueOfficePdf, InterviewEvaluationModal },
  data() {
    return {
      isMobile: false,
      scheduleFilters: {
        status: "all",
        candidate_param: "",
        interviewer_param: "",
        position: "",
        recruiter_param: "",
      },
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      allInterviews: [],
      interviewTotal: 0,
      tableLoading: false,
      mobileHasMore: true,
      mobileLoadingMore: false,
      showModal: false,
      modalMode: "create",
      editingId: null,
      form: {
        candidate: "",
        phone: "",
        candidateEmail: "",
        interviewerId: "",
        interviewer: "",
        interviewerWorkNo: "",
        interviewerPhone: "",
        interviewerEmail: "",
        time: "",
        interviewDate: "",
        startTime: "",
        endTime: "",
        position: "",
        resume: "",
        resumeFileName: "",
        resumeFile: null,
      },
      interviewerOptions: [],
      interviewerFirstPage: [],
      interviewerLoading: false,
      createErrors: {},
      createValidationActive: false,
      createFormInitializing: false,
      interviewSubmitting: false,
      showEvalModal: false,
      evalInterview: null,
      evalScores: {
        skill_match: null,
        communication: null,
        problem_solving: null,
        work_thought: null,
        technical_basis: null,
        comprehensive_score: null,
        evaluation_result: null,
        text_evaluation: "",
      },
      evalErrors: {},
      evalValidationActive: false,
      evalSubmitting: false,
      showResumePreviewModal: false,
      resumePreviewLoading: false,
      resumePreviewUrl: "",
      resumePreviewObjectUrl: "",
      resumePreviewFileName: "",
      resumePreviewDisplayName: "",
      resumePreviewType: "",
      sendingNotification: false,
      sendingNotificationInterviewId: null,
    };
  },
  computed: {
    pageTitle() {
      return (this.$route.meta && this.$route.meta.title) || "面试安排";
    },
    pageSub() {
      return (this.$route.meta && this.$route.meta.subTitle) || "";
    },
    scheduleColumns() {
      return [
        { label: "面试时间", slot: "interviewTime", minWidth: 180 },
        { label: "候选人", slot: "candidate", minWidth: 90 },
        { label: "候选人电话", prop: "candidate_phone", minWidth: 120 },
        { label: "候选人邮箱", slot: "candidateEmail", minWidth: 160 },
        { label: "面试官", slot: "interviewerName", minWidth: 90 },
        { label: "面试官电话", slot: "interviewerPhone", minWidth: 120 },
        { label: "面试官邮箱", slot: "interviewerEmail", minWidth: 160 },
        { label: "面试岗位", prop: "position", minWidth: 120 },
        { label: "招聘HR", slot: "recruiterName", minWidth: 90 },
        { label: "HR电话", slot: "recruiterPhone", minWidth: 120 },
        { label: "候选人简历", slot: "resume", minWidth: 140 },
        { label: "状态", slot: "current_status", minWidth: 90 },
        {
          label: "操作",
          slot: "actions",
          minWidth: !this.scheduleFilters || !this.scheduleFilters.status || this.scheduleFilters.status === "all" ? 270 : 240,
          fixed: "right",
        },
      ];
    },
    statsSummary() {
      // 列表状态字段：使用 current_status（数字）
      const pendingNotify = this.allInterviews.filter((iv) => Number(iv.current_status) === 0).length;
      const pending = this.allInterviews.filter((iv) => Number(iv.current_status) === 1).length;
      const ongoing = this.allInterviews.filter((iv) => Number(iv.current_status) === 2).length;
      const pendingEval = this.allInterviews.filter((iv) => Number(iv.current_status) === 3).length;
      return `📊 待通知:${pendingNotify} 待开始:${pending} 进行中:${ongoing} 待评价:${pendingEval}`;
    },
    scheduleFilterSchema() {
      return [
        {
          label: "状态",
          field: "status",
          type: "select",
          options: [
            { label: "全部", value: "all" },
            { label: "待通知", value: "0" },
            { label: "待开始", value: "1" },
            { label: "进行中", value: "2" },
            { label: "待评价", value: "3" },
          ],
        },
        {
          label: "候选人姓名/电话",
          field: "candidate_param",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "面试官姓名/电话",
          field: "interviewer_param",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "面试岗位",
          field: "position",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "招聘HR/电话",
          field: "recruiter_param",
          type: "input",
          placeholder: "请输入",
        },
      ];
    },
    modalTitle() {
      return this.modalMode === "create" ? "添加新面试" : "编辑面试";
    },
    userName() {
      return this.$route.query.user || "王面试官";
    },
    resumePreviewIframeSrc() {
      // 仅在拿到实际 PDF blob URL 时才用于预览，避免把 about:blank 等占位地址传给 PDF 组件
      return this.resumePreviewUrl || "";
    },
    endTimeDisabled() {
      const startMinutes = this.parseTimeToMinutes(this.form.startTime);
      return Number.isFinite(startMinutes) && startMinutes >= 23 * 60 + 59;
    },
    endTimePickerOptions() {
      const fullRange = "00:00:00 - 23:59:59";
      const startMinutes = this.parseTimeToMinutes(this.form.startTime);
      if (!Number.isFinite(startMinutes)) {
        return { selectableRange: fullRange };
      }
      if (startMinutes >= 23 * 60 + 59) {
        return { selectableRange: "23:59:59 - 23:59:59" };
      }
      const minMinutes = startMinutes + 1;
      return {
        selectableRange: `${this.formatMinutesToTime(minMinutes)}:00 - 23:59:59`,
      };
    },
  },
  created() {
    this.fetchInterviews();
  },
  mounted() {
    this.updateIsMobile();
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.updateIsMobile);
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.updateIsMobile);
    }
  },
  watch: {
    "form.candidate"() {
      this.revalidateCreateField("candidate");
    },
    "form.phone"() {
      this.revalidateCreateField("phone");
    },
    "form.candidateEmail"() {
      this.revalidateCreateField("candidateEmail");
    },
    "form.interviewerId"() {
      this.revalidateCreateField("interviewerId");
    },
    "form.interviewerPhone"() {
      this.revalidateCreateField("interviewerPhone");
    },
    "form.interviewerEmail"() {
      this.revalidateCreateField("interviewerEmail");
    },
    "form.interviewDate"() {
      this.revalidateCreateField("timeRange");
    },
    "form.startTime"() {
      this.revalidateCreateField("timeRange");
    },
    "form.endTime"() {
      this.revalidateCreateField("timeRange");
    },
    "form.position"() {
      this.revalidateCreateField("position");
    },
    "form.resume"() {
      this.revalidateCreateField("resume");
    },
    "form.resumeFile"() {
      this.revalidateCreateField("resume");
    },

    // ===== 面试评价必填校验（参考添加面试：弹窗开启后字段变化才触发 revalidate）=====
    "evalScores.skill_match"() {
      this.revalidateEvalField("skill_match");
    },
    "evalScores.communication"() {
      this.revalidateEvalField("communication");
    },
    "evalScores.problem_solving"() {
      this.revalidateEvalField("problem_solving");
    },
    "evalScores.work_thought"() {
      this.revalidateEvalField("work_thought");
    },
    "evalScores.technical_basis"() {
      this.revalidateEvalField("technical_basis");
    },
    "evalScores.text_evaluation"() {
      this.revalidateEvalField("text_evaluation");
    },
    "evalScores.evaluation_result"() {
      this.revalidateEvalField("evaluation_result");
    },
  },
  methods: {
    getResumeMaxSizeBytes() {
      return 10 * 1024 * 1024;
    },
    parseTimeToMinutes(timeText) {
      const text = String(timeText || "").trim();
      const match = text.match(/^(\d{2}):(\d{2})$/);
      if (!match) return NaN;
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return NaN;
      return hours * 60 + minutes;
    },
    formatMinutesToTime(totalMinutes) {
      const safe = Math.max(0, Math.min(23 * 60 + 59, Number(totalMinutes) || 0));
      const hours = Math.floor(safe / 60);
      const minutes = safe % 60;
      return `${this.pad2(hours)}:${this.pad2(minutes)}`;
    },
    onStartTimeChange() {
      const startMinutes = this.parseTimeToMinutes(this.form.startTime);
      const endMinutes = this.parseTimeToMinutes(this.form.endTime);
      if (!Number.isFinite(startMinutes) || !Number.isFinite(endMinutes)) return;
      if (endMinutes <= startMinutes) {
        this.form.endTime = "";
      }
    },
    disableInterviewPastDate(time) {
      // 禁用今天之前的日期（允许选择今天）
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return time.getTime() < today.getTime();
    },
    updateIsMobile() {
      if (typeof window === "undefined") {
        this.isMobile = false;
        return;
      }
      this.isMobile = window.innerWidth <= 768;
    },
    validateCreateField(field) {
      let error = "";
      switch (field) {
        case "candidate":
          if (!String(this.form.candidate || "").trim()) error = "请输入候选人姓名";
          break;
        case "phone":
          if (!isMobile11(this.form.phone)) error = "请输入正确的候选人手机号（11位）";
          break;
        case "candidateEmail":
          if (!isEmail(this.form.candidateEmail)) error = "请输入正确的候选人邮箱";
          break;
        case "interviewerId":
          if (!this.form.interviewerId) error = "请选择面试官";
          break;
        case "interviewerPhone":
          if (!String(this.form.interviewerPhone || "").trim()) error = "请选择面试官后自动带出电话";
          else if (!isMobile11(this.form.interviewerPhone)) error = "面试官手机号格式不正确（11位）";
          break;
        case "interviewerEmail":
          if (!String(this.form.interviewerEmail || "").trim()) error = "请选择面试官后自动带出邮箱";
          else if (!isEmail(this.form.interviewerEmail)) error = "面试官邮箱格式不正确";
          break;
        case "timeRange":
          if (!this.form.interviewDate || !this.form.startTime || !this.form.endTime) error = "请选择完整面试时间";
          break;
        case "position":
          if (!String(this.form.position || "").trim()) error = "请输入职位";
          break;
        case "resume":
          if (!String(this.form.resume || "").trim() && !this.form.resumeFile) error = "请上传简历文件";
          break;
        default:
          break;
      }
      if (error) this.$set(this.createErrors, field, error);
      else this.$delete(this.createErrors, field);
      return !error;
    },
    validateCreateForm() {
      this.createValidationActive = true;
      const fields = [
        "candidate",
        "phone",
        "candidateEmail",
        "interviewerId",
        "interviewerPhone",
        "interviewerEmail",
        "timeRange",
        "position",
        "resume",
      ];
      let pass = true;
      fields.forEach((field) => {
        const ok = this.validateCreateField(field);
        if (!ok) pass = false;
      });
      return pass;
    },
    revalidateCreateField(field) {
      if (!this.createValidationActive) return;
      if (this.createFormInitializing) return;
      this.validateCreateField(field);
    },

    validateEvalField(field) {
      let error = "";
      switch (field) {
        case "skill_match": {
          const raw = this.evalScores.skill_match;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 35) error = "分数需在 0-35 之间";
          }
          break;
        }
        case "communication": {
          const raw = this.evalScores.communication;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 20) error = "分数需在 0-20 之间";
          }
          break;
        }
        case "problem_solving": {
          const raw = this.evalScores.problem_solving;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "work_thought": {
          const raw = this.evalScores.work_thought;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "technical_basis": {
          const raw = this.evalScores.technical_basis;
          if (raw === "" || raw === null || raw === undefined) error = "请输入分数";
          else {
            const v = Number(raw);
            if (!Number.isFinite(v)) error = "请输入分数";
            else if (v < 0 || v > 15) error = "分数需在 0-15 之间";
          }
          break;
        }
        case "text_evaluation": {
          const txt = String(this.evalScores.text_evaluation || "");
          if (!txt.trim()) error = "请输入面试评语";
          else if (txt.length > 200) error = "面试评语最多 200 个字符";
          break;
        }
        case "evaluation_result": {
          const raw = this.evalScores.evaluation_result;
          if (raw == null || raw === "") error = "请选择面试结果";
          else {
            const v = Number(raw);
            if (!(v === 0 || v === 1)) error = "请选择面试结果";
          }
          break;
        }
        default:
          break;
      }

      if (error) this.$set(this.evalErrors, field, error);
      else this.$delete(this.evalErrors, field);
      return !error;
    },
    validateEvalForm() {
      this.evalValidationActive = true;
      const fields = [
        "skill_match",
        "communication",
        "problem_solving",
        "work_thought",
        "technical_basis",
        "text_evaluation",
        "evaluation_result",
      ];
      let pass = true;
      fields.forEach((f) => {
        const ok = this.validateEvalField(f);
        if (!ok) pass = false;
      });
      return pass;
    },
    revalidateEvalField(field) {
      if (!this.evalValidationActive) return;
      this.validateEvalField(field);
    },
    onEvalScoreUpdate(payload) {
      const field = payload && payload.field;
      if (!field) return;
      this.$set(this.evalScores, field, payload.value);
      this.recalculateEvalDerivedFields();
    },
    recalculateEvalDerivedFields() {
      const fields = ["skill_match", "communication", "problem_solving", "work_thought", "technical_basis"];
      const nums = fields.map((key) => {
        const raw = this.evalScores[key];
        if (raw === "" || raw === null || raw === undefined) return NaN;
        return Number(raw);
      });
      const allValid = nums.every((v) => Number.isFinite(v));
      const total = allValid ? nums.reduce((sum, v) => sum + v, 0) : null;
      this.$set(this.evalScores, "comprehensive_score", total);
      if (allValid) {
        this.$set(this.evalScores, "evaluation_result", total >= 60 ? 1 : 0);
      }
    },

    ensureSelectedInterviewerOption() {
      const id = this.form && this.form.interviewerId;
      if (id == null || id === "") return;

      const exists = (this.interviewerOptions || []).some((it) => String(it.userid) === String(id));
      if (exists) return;

      // 只有在回填信息足够时，才插入当前面试官选项
      const name = this.form.interviewer || "";
      const phone = this.form.interviewerPhone || "";
      const email = this.form.interviewerEmail || "";
      const workNo = this.form.interviewerWorkNo || "";
      if (!name && !phone && !email) return;

      this.interviewerOptions = (this.interviewerOptions || []).concat([
        {
          userid: id,
          name,
          phone,
          email,
          work_no: workNo,
        },
      ]);
    },

    async onInterviewerRemoteSearch(query) {
      const q = String(query || "").trim();

      // 清空搜索时：加载默认第一页数据（并保留编辑态回填选项）
      if (!q) {
        // 优先用已缓存的第一页数据，避免每次都打接口
        if (this.interviewerFirstPage && this.interviewerFirstPage.length) {
          this.interviewerOptions = this.interviewerFirstPage.slice();
          this.ensureSelectedInterviewerOption();
          return;
        }
        await this.loadInitialInterviewers();
        return;
      }

      this.interviewerLoading = true;
      try {
        const res = await listInterviewers({ page_num: 1, page_size: 10, query: q });
        const payload =
          res && (Array.isArray(res.rows) || typeof res.total === "number")
            ? res
            : res && res.data
              ? res.data
              : res;
        const rows = payload && Array.isArray(payload.rows) ? payload.rows : Array.isArray(payload) ? payload : [];
        // 兼容不同后端返回字段命名，统一成 el-select 需要的字段
        this.interviewerOptions = rows.map((it) => ({
          userid: it.userid ?? it.user_id ?? it.id ?? it.userId,
          name: it.name ?? it.user_name ?? it.username ?? it.real_name ?? "",
          work_no: it.work_no ?? it.workNo ?? it.workno ?? "",
          phone: it.phone ?? it.mobile ?? it.tel ?? "",
          email: it.email ?? it.mail ?? "",
        }));
      } catch (e) {
        this.interviewerOptions = [];
        // eslint-disable-next-line no-console
        console.error("onInterviewerRemoteSearch failed:", e);
      } finally {
        this.interviewerLoading = false;
        // 回填编辑态：保证当前选项一定在下拉里
        this.ensureSelectedInterviewerOption();
      }
    },

    async loadInitialInterviewers() {
      this.interviewerLoading = true;
      try {
        const res = await listInterviewers({ page_num: 1, page_size: 10, query: "" });
        const payload =
          res && (Array.isArray(res.rows) || typeof res.total === "number")
            ? res
            : res && res.data
              ? res.data
              : res;
        const rows = payload && Array.isArray(payload.rows) ? payload.rows : Array.isArray(payload) ? payload : [];
        const mapped = rows.map((it) => ({
          userid: it.userid ?? it.user_id ?? it.id ?? it.userId,
          name: it.name ?? it.user_name ?? it.username ?? it.real_name ?? "",
          work_no: it.work_no ?? it.workNo ?? it.workno ?? "",
          phone: it.phone ?? it.mobile ?? it.tel ?? "",
          email: it.email ?? it.mail ?? "",
        }));
        // 缓存第一页数据（编辑回填判断用）
        this.interviewerFirstPage = mapped;
        // 下拉默认显示第一页
        this.interviewerOptions = mapped.slice();
      } catch (e) {
        this.interviewerOptions = [];
        this.interviewerFirstPage = [];
        // eslint-disable-next-line no-console
        console.error("loadInitialInterviewers failed:", e);
      } finally {
        this.interviewerLoading = false;
        this.ensureSelectedInterviewerOption();
      }
    },
    onInterviewerChange(userid) {
      const picked = (this.interviewerOptions || []).find((i) => String(i.userid) === String(userid));
      if (!picked) return;
      this.form.interviewer = picked.name || "";
      this.form.interviewerWorkNo = picked.work_no || "";
      this.form.interviewerPhone = picked.phone || "";
      this.form.interviewerEmail = picked.email || "";
    },
    parseInterviewTimeToParts(interviewTime) {
      const s = (interviewTime || "").trim();
      if (!s) return { date: "", start: "", end: "" };
      const m = s.match(/^(\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2})\s*-\s*(\d{2}:\d{2})$/);
      if (!m) return { date: "", start: "", end: "" };
      return {
        date: m[1].slice(0, 10),
        start: m[1].slice(11, 16),
        end: m[2],
      };
    },
    toDateObj(v) {
      if (!v) return null;
      return v instanceof Date ? v : new Date(String(v).replace(/-/g, "/"));
    },
    pad2(v) {
      return String(v).padStart(2, "0");
    },
    formatDateTime(dt) {
      return `${dt.getFullYear()}-${this.pad2(dt.getMonth() + 1)}-${this.pad2(dt.getDate())} ${this.pad2(
        dt.getHours()
      )}:${this.pad2(dt.getMinutes())}`;
    },
    normalizeInterviewTimeRange() {
      const date = this.form.interviewDate;
      const startT = this.form.startTime;
      const endT = this.form.endTime;
      if (!date || !startT || !endT) {
        this.$message.warning("请选择完整的面试日期和时间段");
        return "";
      }
      const start = this.toDateObj(`${date} ${startT}`);
      const end = this.toDateObj(`${date} ${endT}`);
      if (!start || !end) return "";

      const diffMs = end.getTime() - start.getTime();
      if (diffMs < 30 * 60 * 1000) {
        this.$message.warning("结束时间至少比开始时间晚 30 分钟");
        return "";
      }

      const startText = this.formatDateTime(start);
      const endText = `${this.pad2(end.getHours())}:${this.pad2(end.getMinutes())}`;
      return `${startText}-${endText}`;
    },
    onScheduleFilterChange() {
      // 筛选变更时重置分页，重新拉取列表
      this.page.pageNo = 1;
      this.page.pageSize = 10;
      this.mobileHasMore = true;
      this.fetchInterviews(1);
      this.$nextTick(() => {
        const list = this.$refs.mobileCardList;
        if (list && typeof list.scrollTop === "number") list.scrollTop = 0;
      });
    },
    async fetchInterviews(pageNum, options = {}) {
      const append = !!(options && options.append);
      if (this.isMobile && append) {
        if (this.mobileLoadingMore || !this.mobileHasMore) return;
        this.mobileLoadingMore = true;
      }
      const nextPage = pageNum != null ? parseInt(pageNum, 10) || 1 : this.page.pageNo;
      this.page.pageNo = nextPage;
      // 后端分页：直接请求当前页数据
      const statusVal = this.scheduleFilters && this.scheduleFilters.status;
      const current_status =
        !statusVal || statusVal === "all" ? null : parseInt(statusVal, 10);
      const candidate_param = String(
        (this.scheduleFilters && this.scheduleFilters.candidate_param) || ""
      ).trim();
      const interviewer_param = String(
        (this.scheduleFilters && this.scheduleFilters.interviewer_param) || ""
      ).trim();
      const position = String((this.scheduleFilters && this.scheduleFilters.position) || "").trim();
      const recruiter_param = String(
        (this.scheduleFilters && this.scheduleFilters.recruiter_param) || ""
      ).trim();
      if (!(this.isMobile && append)) this.tableLoading = true;
      try {
        const res = await listInterview({
          current_status,
          candidate_param,
          interviewer_param,
          position,
          recruiter_param,
          page_num: this.page.pageNo,
          page_size: this.page.pageSize,
        });
        const payload =
          res && (Array.isArray(res.rows) || typeof res.total === "number") ? res : res && res.res ? res.res : {};
        this.interviewTotal = payload && typeof payload.total === "number" ? payload.total : 0;
        const rows = Array.isArray(payload && payload.rows) ? payload.rows : [];
        this.allInterviews = this.isMobile && append ? this.allInterviews.concat(rows) : rows;
        this.mobileHasMore = this.allInterviews.length < this.interviewTotal;
      } catch (e) {
        // 这里不抛 warning 弹窗，避免原型演示里打断交互
        if (!(this.isMobile && append)) {
          this.interviewTotal = 0;
          this.allInterviews = [];
        }
        this.mobileHasMore = false;
        // eslint-disable-next-line no-console
        console.error("fetchInterviews failed:", e);
      } finally {
        if (this.isMobile && append) {
          this.mobileLoadingMore = false;
        } else {
          this.tableLoading = false;
        }
      }
    },
    handleMobileListScroll(event) {
      if (!this.isMobile || this.tableLoading || this.mobileLoadingMore || !this.mobileHasMore) return;
      const target = event && event.target;
      if (!target) return;
      const remain = target.scrollHeight - target.scrollTop - target.clientHeight;
      if (remain > 80) return;
      const nextPage = (Number(this.page.pageNo) || 1) + 1;
      this.fetchInterviews(nextPage, { append: true });
    },
    getStatusMeta(currentStatus) {
      const n = Number(currentStatus);
      const map = {
        0: { text: "待通知", cls: "gray" },
        1: { text: "待开始", cls: "ok" },
        2: { text: "进行中", cls: "blue" },
        3: { text: "待评价", cls: "warn" },
        4: { text: "待复核", cls: "warn" },
        5: { text: "复核淘汰", cls: "bad" },
        6: { text: "复核通过", cls: "ok" },
      };
      return map[n] || { text: "未知状态", cls: "warn" };
    },
    statusText(row) {
      return this.getStatusMeta(row && row.current_status).text;
    },
    statusClass(row) {
      return this.getStatusMeta(row && row.current_status).cls;
    },
    goInterviewDetail(row) {
      const resumeRaw = row && row.resume;
      const resume = typeof resumeRaw === "object" ? JSON.stringify(resumeRaw || {}) : resumeRaw || "";
      this.$router.push({
        name: "interviewDetail",
        query: {
          from: this.$route.name || "interviewer-dashboard-schedule",
          id: (row && row.id) || "",
          interview_time: (row && row.interview_time) || "",
          candidate_name: (row && row.candidate_name) || "",
          candidate_phone: (row && row.candidate_phone) || "",
          candidate_email: (row && row.candidate_email) || "",
          interviewer_name: (row && row.interviewer_info && row.interviewer_info.name) || "",
          interviewer_phone: (row && row.interviewer_info && row.interviewer_info.phone) || "",
          interviewer_email: (row && row.interviewer_info && row.interviewer_info.email) || "",
          position: (row && row.position) || "",
          recruiter_name: (row && row.recruiter_info && row.recruiter_info.name) || "",
          recruiter_phone: (row && row.recruiter_info && row.recruiter_info.phone) || "",
          current_status: row && row.current_status != null ? String(row.current_status) : "",
          resume,
        },
      });
    },
    parseResumeMeta(row) {
      const raw = row && row.resume;
      if (!raw) return {};
      if (typeof raw === "object") return raw || {};
      try {
        return JSON.parse(raw);
      } catch (e) {
        return {};
      }
    },
    resumeText(row) {
      const meta = this.parseResumeMeta(row);
      return meta.originalFilename || meta.fileName || "简历";
    },
    /** 列表中有文件名且非 PDF：用灰色链样式（仍可点击出「不支持预览」提示） */
    isResumeListNonPdf(row) {
      const meta = this.parseResumeMeta(row);
      const fileName = meta.fileName || meta.originalFilename || "";
      if (!fileName) return false;
      return !this.isPdfFileName(fileName);
    },
    async downloadResume(row) {
      const meta = this.parseResumeMeta(row);
      // 按后端约定传入 fileName
      const fileName = meta.fileName || meta.originalFilename || "";
      if (!fileName) {
        this.$message.warning("未找到简历文件名，无法下载");
        return;
      }
      await this.downloadResumeByFileName(fileName, meta.originalFilename || meta.fileName || "download");
    },
    async downloadResumeByFileName(fileName, downloadName = "download") {
      const resolvedFileName = String(fileName || "").trim();
      if (!resolvedFileName) {
        this.$message.warning("未找到简历文件名，无法下载");
        return;
      }
      try {
        // 通用下载接口：/common/download?fileName=xxx&delete=false
        const res = await commonGet("/common/download", { fileName: resolvedFileName, delete: false }, { responseType: "blob" });
        const blob = res && res.data instanceof Blob ? res.data : res && res.data ? new Blob([res.data]) : null;
        if (!blob) {
          this.$message.warning("下载失败：未获取到文件内容");
          return;
        }

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // 尽量使用原始文件名展示
        a.download = downloadName || "download";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("downloadResume failed:", e);
        this.$message.warning("下载失败");
      }
    },
    isPdfFileName(name) {
      const s = String(name || "").trim().toLowerCase();
      return s.endsWith(".pdf");
    },
    getResumePreviewType(name) {
      if (this.isPdfFileName(name)) return "pdf";
      return "";
    },
    async previewResumeFromList(row) {
      const meta = this.parseResumeMeta(row);
      const fileName = meta.fileName || meta.originalFilename || "";
      if (!fileName) {
        this.$message.warning("未找到简历文件，无法预览");
        return;
      }
      const previewType = this.getResumePreviewType(fileName);
      if (!previewType) {
        this.$message.warning("当前格式不支持预览，可前往面试详情页下载。");
        return;
      }
      if (this.resumePreviewObjectUrl) {
        window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
        this.resumePreviewObjectUrl = "";
      }
      this.resumePreviewUrl = "";
      this.resumePreviewFileName = fileName;
      this.resumePreviewDisplayName = meta.originalFilename || meta.fileName || "简历";
      this.resumePreviewType = previewType;
      this.resumePreviewLoading = true;
      this.showResumePreviewModal = true;
      try {
        const res = await commonGet(
          "/common/download",
          { fileName, delete: false },
          { responseType: "blob" }
        );
        const blob = res && res.data instanceof Blob ? res.data : res instanceof Blob ? res : null;
        if (!blob) {
          this.$message.warning("PDF 预览失败：未获取到文件内容");
          this.showResumePreviewModal = false;
          this.resumePreviewLoading = false;
          return;
        }
        const url = window.URL.createObjectURL(blob);
        this.$nextTick(() => {
          this.resumePreviewUrl = url;
          this.resumePreviewObjectUrl = url;
          this.resumePreviewLoading = false;
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("preview pdf failed:", e);
        this.$message.warning("PDF 预览失败");
        this.showResumePreviewModal = false;
        this.resumePreviewLoading = false;
      }
    },
    openResumePreviewModal(url, isObjectUrl = false) {
      if (!url) return;
      // 若上一次是 blob 预览，先释放旧对象 URL，避免泄漏
      if (this.resumePreviewObjectUrl) {
        window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
        this.resumePreviewObjectUrl = "";
      }

      // 先清空再赋值，确保 iframe 重新加载
      this.resumePreviewUrl = "";
      this.resumePreviewFileName = "";
      this.resumePreviewDisplayName = "";
      this.resumePreviewType = "";
      this.showResumePreviewModal = true;
      this.$nextTick(() => {
        this.resumePreviewUrl = url;
        this.resumePreviewObjectUrl = isObjectUrl ? url : "";
        this.resumePreviewLoading = false;
      });
    },
    closeResumePreviewModal() {
      this.showResumePreviewModal = false;
      this.resumePreviewUrl = "";
      this.resumePreviewLoading = false;
      this.resumePreviewFileName = "";
      this.resumePreviewDisplayName = "";
      this.resumePreviewType = "";
      if (this.resumePreviewObjectUrl) {
        window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
        this.resumePreviewObjectUrl = "";
      }
    },
    async onResumeFileNameClick() {
      // 有本地未提交文件：优先用本地预览
      if (this.form.resumeFile) {
        const previewType = this.getResumePreviewType(this.form.resumeFileName);
        if (previewType) {
          if (this.resumePreviewObjectUrl) {
            window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
            this.resumePreviewObjectUrl = "";
          }
          const file = this.form.resumeFile;
          const url = window.URL.createObjectURL(file);
          this.resumePreviewFileName = this.form.resumeFileName || "";
          this.resumePreviewDisplayName = this.form.resumeFileName || "简历";
          this.resumePreviewType = previewType;
          this.showResumePreviewModal = true;
          this.resumePreviewLoading = false;
          this.resumePreviewUrl = "";
          this.$nextTick(() => {
            this.resumePreviewUrl = url;
            this.resumePreviewObjectUrl = url;
          });
          return;
        }
        this.$message.warning("当前格式不支持预览");
        return;
      }

      // 已存在的线上附件（编辑态：resume 为 JSON 字符串）
      if (!this.form.resume) {
        const input = this.$refs.resumeInput;
        if (input && typeof input.click === "function") input.click();
        return;
      }

      const meta = this.parseResumeMeta({ resume: this.form.resume });
      const fileName = meta.fileName || meta.originalFilename || "";
      const previewType = this.getResumePreviewType(fileName);
      if (!previewType) {
        this.$message.warning("当前格式不支持预览");
        return;
      }

      // OBS 默认域名会强制下载，PDF 预览统一走下载接口 + blob URL
      if (this.resumePreviewObjectUrl) {
        window.URL.revokeObjectURL(this.resumePreviewObjectUrl);
        this.resumePreviewObjectUrl = "";
      }
      this.resumePreviewUrl = "";
      this.resumePreviewFileName = fileName;
      this.resumePreviewDisplayName = meta.originalFilename || meta.fileName || "简历";
      this.resumePreviewType = previewType;
      this.resumePreviewLoading = true;
      this.showResumePreviewModal = true;
      try {
        const res = await commonGet(
          "/common/download",
          { fileName, delete: false },
          { responseType: "blob" }
        );
        const blob = res && res.data instanceof Blob ? res.data : res instanceof Blob ? res : null;
        if (!blob) {
          this.$message.warning("PDF 预览失败：未获取到文件内容");
          this.showResumePreviewModal = false;
          this.resumePreviewLoading = false;
          return;
        }
        const url = window.URL.createObjectURL(blob);
        this.$nextTick(() => {
          this.resumePreviewUrl = url;
          this.resumePreviewObjectUrl = url;
          this.resumePreviewLoading = false;
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("preview pdf failed:", e);
        this.$message.warning("PDF 预览失败");
        this.showResumePreviewModal = false;
        this.resumePreviewLoading = false;
      }
    },
    showCreateForm() {
      this.modalMode = "create";
      this.editingId = null;
      this.createErrors = {};
      this.createValidationActive = true;
      this.createFormInitializing = true;
      this.form = {
        candidate: "",
        phone: "",
        candidateEmail: "",
        interviewerId: null,
        interviewer: "",
        interviewerWorkNo: "",
        interviewerPhone: "",
        interviewerEmail: "",
        time: "",
        interviewDate: "",
        startTime: "",
        endTime: "",
        position: "",
        resume: "",
        resumeFileName: "",
        resumeFile: null,
      };
      this.interviewerOptions = [];
      this.loadInitialInterviewers();
      this.showModal = true;
      this.$nextTick(() => {
        const input = this.$refs.resumeInput;
        if (input) input.value = "";
        this.createFormInitializing = false;
      });
    },
    async showEditForm(iv) {
      this.modalMode = "edit";
      this.editingId = iv.id;
      this.createErrors = {};
      this.createValidationActive = true;
      this.createFormInitializing = true;

      const interviewerId = iv && iv.interviewer_info && iv.interviewer_info.userid ? String(iv.interviewer_info.userid) : null;
      const resumeMeta = this.parseResumeMeta(iv);
      const timeParts = this.parseInterviewTimeToParts(iv.interview_time || "");
      this.form = {
        candidate: (iv && iv.candidate_name) || "",
        phone: (iv && iv.candidate_phone) || "",
        candidateEmail: (iv && iv.candidate_email) || "",
        interviewerId,
        interviewer: (iv && iv.interviewer_info && iv.interviewer_info.name) || "",
        interviewerWorkNo: (iv && iv.interviewer_info && iv.interviewer_info.work_no) || "",
        interviewerPhone: (iv && iv.interviewer_info && iv.interviewer_info.phone) || "",
        interviewerEmail: (iv && iv.interviewer_info && iv.interviewer_info.email) || "",
        time: iv.interview_time || "",
        interviewDate: timeParts.date,
        startTime: timeParts.start,
        endTime: timeParts.end,
        position: (iv && iv.position) || "",
        resume: (iv && iv.resume) || "",
        // 简历可能是 JSON 字符串，优先展示 originalFilename/fileName
        resumeFileName: resumeMeta.originalFilename || resumeMeta.fileName || "",
        resumeFile: null,
      };

      // 先加载并缓存第一页下拉数据，再判断是否需要把当前面试官 push 到下拉
      if (this.interviewerFirstPage && this.interviewerFirstPage.length) {
        this.interviewerOptions = this.interviewerFirstPage.slice();
      } else {
        await this.loadInitialInterviewers();
      }

      // 回填面试官信息：若第一页不包含当前面试官，则 push 当前面试官到下拉
      this.ensureSelectedInterviewerOption();
      // 接口有可能 interviewer_info 为 null，此时兜底用当前 id 触发一次远程查询
      if (this.form.interviewerId && !this.form.interviewer) {
        await this.onInterviewerRemoteSearch(this.form.interviewerId);
        this.onInterviewerChange(this.form.interviewerId);
      }

      this.showModal = true;
      this.$nextTick(() => {
        const input = this.$refs.resumeInput;
        if (input) input.value = "";
        this.createFormInitializing = false;
      });
    },
    onResumeChange(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;

      if (file.size > this.getResumeMaxSizeBytes()) {
        this.$message.warning("简历文件不能超过10MB");
        this.form.resumeFile = null;
        this.form.resumeFileName = "";
        const input = this.$refs.resumeInput;
        if (input) input.value = "";
        return;
      }

      this.form.resumeFile = file;
      this.form.resumeFileName = file.name;
    },
    removeResumeAttachment() {
      this.form.resume = "";
      this.form.resumeFile = null;
      this.form.resumeFileName = "";
      this.$nextTick(() => {
        const input = this.$refs.resumeInput;
        if (input) input.value = "";
      });
      this.revalidateCreateField("resume");
    },
    async buildResumePayload() {
      // 新选文件：先走 /common/upload，再把关键返回字段序列化到 resume
      if (this.form.resumeFile) {
        const uploadRes = await uploadCommonFile(this.form.resumeFile, this.form.resumeFile.name);
        const resumeObj = {
          fileName: uploadRes && uploadRes.fileName ? uploadRes.fileName : "",
          originalFilename: uploadRes && uploadRes.originalFilename ? uploadRes.originalFilename : ""
        };
        return JSON.stringify(resumeObj);
      }
      // 未重新上传：沿用已有值
      return this.form.resume || "";
    },
    async confirmModal() {
      if (this.interviewSubmitting) return;
      if (!this.validateCreateForm()) return;
      const interviewTimeText = this.normalizeInterviewTimeRange();
      if (!interviewTimeText) return;

      this.interviewSubmitting = true;
      try {
        const resumePayload = await this.buildResumePayload();
        if (this.modalMode === "create") {
          const createPayload = {
            candidate_name: this.form.candidate || "",
            candidate_phone: this.form.phone || "",
            candidate_email: this.form.candidateEmail || "",
            position: this.form.position || "",
            resume: resumePayload,
            interview_time: interviewTimeText,
            interviewers_id: this.form.interviewerId,
          };
          await createInterview(createPayload);
          // 添加成功后不做本地插入，统一重置筛选并重新请求列表
          this.scheduleFilter = "all";
          this.scheduleKeyword = "";
          this.page.pageNo = 1;
          this.page.pageSize = 10;
          await this.fetchInterviews(1);
          this.showModal = false;
          this.$message.success(`已添加 ${this.form.candidate} 的面试`);
        } else {
          if (!this.editingId) {
            this.$message.warning("未找到要编辑的记录");
            return;
          }
          const updatePayload = {
            candidate_name: this.form.candidate || "",
            candidate_phone: this.form.phone || "",
            candidate_email: this.form.candidateEmail || "",
            position: this.form.position || "",
            resume: resumePayload,
            interview_time: interviewTimeText,
            interviewers_id: this.form.interviewerId || "",
          };
          await updateInterview(this.editingId, updatePayload);
          await this.fetchInterviews(this.page.pageNo);
          this.showModal = false;
          this.$message.success("面试信息已更新");
        }
      } finally {
        this.interviewSubmitting = false;
      }
    },
    async sendNotification(iv) {
      if (this.sendingNotification) {
        this.$message.info("通知发送中，请稍候");
        return;
      }
      if (!iv || iv.id == null) {
        this.$message.warning("数据无效，无法发送通知");
        return;
      }
      try {
        await this.$confirm("确定向候选人与面试官发送面试通知？", "发送通知", { type: "warning" });
      } catch (_) {
        return;
      }
      try {
        this.sendingNotification = true;
        this.sendingNotificationInterviewId = iv.id;
        // 按要求：直接透传整行数据给后端
        const payload = { ...(iv || {}) };
        // 后端 /interview/send_notification：同时向候选人与面试官发送面试通知
        await sendInterviewNotification(payload);
        const interviewerName =
          iv.interviewer_info && iv.interviewer_info.name ? iv.interviewer_info.name : "面试官";
        this.$message.success(
          `已向候选人 ${iv.candidate_name} 与面试官 ${interviewerName} 发送面试通知`
        );
        await this.fetchInterviews(this.page.pageNo);
      } catch (e) {
        // this.$message.error("发送通知失败");
      } finally {
        this.sendingNotification = false;
        this.sendingNotificationInterviewId = null;
      }
    },
    async sendEvalReminder(iv) {
      if (!iv || iv.id == null) {
        this.$message.warning("数据无效，无法发送评价提醒");
        return;
      }
      try {
        await this.$confirm("确定向面试官发送面试评价提醒？", "评价提醒", { type: "warning" });
      } catch (_) {
        return;
      }
      try {
        // 按要求：直接透传整行数据给后端（与发送通知同接口）
        const payload = { ...(iv || {}) };
        await sendInterviewEvaluationSms(payload);
        const interviewerName =
          iv.interviewer_info && iv.interviewer_info.name ? iv.interviewer_info.name : "面试官";
        this.$message.success(`已向面试官 ${interviewerName} 发送评价提醒`);
      } catch (e) {
        // this.$message.error("发送评价提醒失败");
      }
    },
    async deleteInterview(iv) {
      const id = iv && iv.id;
      const currentStatus = Number(iv && iv.current_status);
      // 仅允许 0/1 状态删除
      if (currentStatus !== 0 && currentStatus !== 1) {
        this.$message.warning("当前状态不允许删除");
        return;
      }
      if (id == null) {
        this.$message.warning("未找到要删除的记录");
        return;
      }

      this.$confirm("确定要删除该面试吗？", "提示", { type: "warning" })
        .then(async () => {
          await deleteInterviewApi(id);
          this.$message.success("面试已删除");
          await this.fetchInterviews(this.page.pageNo);
        })
        .catch(() => {});
    },
    enterRoom(iv) {
      this.$router.push({
        path: "/interviewer/entry",
        query: {
          interviewId: iv.id,
          name: iv.candidate_name
        },
      });
    },
    openEvalModal(iv) {
      this.evalInterview = iv;
      this.evalScores = {
        skill_match: null,
        communication: null,
        problem_solving: null,
        work_thought: null,
        technical_basis: null,
        comprehensive_score: null,
        evaluation_result: null,
        text_evaluation: "",
      };
      this.evalErrors = {};
      this.evalValidationActive = true;
      this.showEvalModal = true;
    },
    closeEvalModal() {
      this.showEvalModal = false;
      this.evalInterview = null;
      this.evalValidationActive = false;
      this.evalErrors = {};
    },
    confirmEval() {
      if (this.evalSubmitting) return;
      if (!this.evalInterview) return;
      if (!this.validateEvalForm()) return;

      const interview_id = this.evalInterview && this.evalInterview.id;

      const s = this.evalScores;
      const p = Number(s.skill_match);
      const c = Number(s.communication);
      const r = Number(s.problem_solving);
      const t = Number(s.work_thought);
      const j = Number(s.technical_basis);
      const comprehensive_score =
        Number.isFinite(Number(s.comprehensive_score))
          ? Number(s.comprehensive_score)
          : p + c + r + t + j;
      const payload = {
        interview_id,
        skill_match: p,
        communication: c,
        problem_solving: r,
        work_thought: t,
        technical_basis: j,
        comprehensive_score,
        text_evaluation: this.evalScores.text_evaluation,
        evaluation_result: this.evalScores.evaluation_result,
      };
      
      this.submitEvalWithRefresh(payload);
    },
    async submitEvalWithRefresh(payload) {
      if (this.evalSubmitting) return;
      this.evalSubmitting = true;
      try {
        await submitEvaluation(payload);
        this.$message.success("面试评价已提交");
        await this.fetchInterviews(this.page.pageNo);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error("submitEvaluation failed:", e);
        // this.$message.warning("面试评价提交失败");
      } finally {
        this.evalSubmitting = false;
        this.closeEvalModal();
      }
    },
  },
};
</script>

<style scoped>
.interviewer-schedule-page {
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .interviewer-schedule-page {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
  }
}

.topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 8px;
  height: 33px;
}

.topTitle {
  font-size: 18px;
  font-weight: 900;
}

.topSub {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.topRight {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 999px;
  border: 1px solid var(--line);
  font-size: 11px;
  color: var(--muted);
  background: #f8fafc;
}

.topActionPlus {
  display: inline-block;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  transform: scale(1.35);
  transform-origin: center;
  margin-right: 4px;
}

.file-upload {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px dashed var(--line);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  cursor: pointer;
  background: #f8fafc;
  transition: all 0.15s;
}

.interview-time-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 12px;
}

.time-date {
  width: 38%;
}

.time-clock {
  width: 26%;
}

.interview-time-row .time-clock:last-child {
  margin-left: auto;
}

.time-sep {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  color: var(--muted);
  font-size: 14px;
  line-height: 1;
}

/* 统一时间选择器：为左右图标留出内边距，避免文字压住日历/时钟图标 */
.interview-time-row /deep/ .el-input__inner {
  height: 36px;
  line-height: 36px;
  margin-bottom: 0;
  padding-left: 30px;
  padding-right: 28px;
}

.interview-time-row /deep/ .el-input__prefix,
.interview-time-row /deep/ .el-input__suffix {
  display: flex;
  align-items: center;
  height: 36px;
}

.interview-time-row /deep/ .el-input__icon {
  line-height: 36px;
}

/* 面试官下拉：宽度随弹框 */
.form-select {
  width: 100%;
}

/* 日期/时间与 el-input 边框圆角统一为 4px（左右 padding 由上一段统一处理） */
.schedule-interview-modal .interview-time-row /deep/ .el-input__inner {
  border-radius: 4px;
}

/* 添加/编辑面试：限制弹窗高度，表单区独立滚动，避免小屏被撑满遮挡 */
.schedule-interview-modal.hr-like-modal {
  display: flex;
  flex-direction: column;
  max-height: min(92vh, 900px);
  overflow: hidden;
}

.schedule-interview-modal.hr-like-modal .modal-header {
  flex-shrink: 0;
}

.schedule-interview-modal.hr-like-modal .modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.schedule-interview-modal.hr-like-modal .modal-actions {
  flex-shrink: 0;
  margin-top: 12px;
}

@media (max-width: 768px) {
  .schedule-interview-modal.hr-like-modal {
    max-height: min(78vh, 100%);
  }
}

@media (max-width: 480px) {
  .schedule-interview-modal.hr-like-modal {
    max-height: min(72vh, 100%);
  }
}

.error-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-top: -8px;
  margin-bottom: 8px;
}


.required-label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.modal-body input.field-error,
.file-upload.field-error {
  border-color: #f56c6c !important;
}

.form-select.field-error /deep/ .el-input__inner,
.interview-time-row.field-error /deep/ .el-input__inner {
  border-color: #f56c6c !important;
}

/* 禁用输入框样式：对齐 Element UI 的灰底禁填效果 */
.modal-body input:disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
}

/* 统一添加/编辑弹窗 placeholder 颜色（input/select/date/time） */
.modal-body input::placeholder {
  color: #c0c4cc;
}

.modal-body /deep/ .el-input__inner::placeholder {
  color: #c0c4cc;
}

.modal-body /deep/ .el-range-input::placeholder {
  color: #c0c4cc;
}

.file-upload:hover {
  border-color: var(--brand);
  background: rgba(66, 112, 241, 0.04);
}

.file-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: var(--muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-upload:hover .file-name {
  color: var(--brand);
}

/* 面试安排列表：候选人简历文件名（PDF 为品牌色可预览；非 PDF 为灰色，点击仍提示不支持预览） */
.resume-download-link {
  display: block;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: none;
  background: transparent;
  padding: 0;
  font-size: inherit;
  color: var(--brand);
  cursor: pointer;
  text-decoration: none;
}

.resume-download-link:hover {
  color: var(--brand);
  opacity: 0.85;
}

.resume-download-link.resume-download-link--non-pdf {
  color: var(--muted);
  cursor: pointer;
}

.resume-download-link.resume-download-link--non-pdf:hover {
  color: var(--text);
  opacity: 1;
}

.candidate-link {
  color: var(--brand);
  text-decoration: none;
  cursor: pointer;
}

.candidate-link:hover {
  color: var(--brand);
  opacity: 0.85;
}

.row-actions {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

/* 覆盖全局 btnLink.small 的 margin/padding，确保行内按钮高度一致 */
.row-actions .btnLink.small {
  margin: 0 !important;
  padding: 2px 5px !important;
  min-height: 24px;
  line-height: 20px;
  white-space: nowrap;
}

.row-actions-wide {
  flex-wrap: nowrap;
}

.file-remove-btn {
  margin-left: auto;
  width: 20px;
  height: 20px;
  min-width: 20px;
  padding: 0;
  border: 1px solid #c0c4cc;
  border-radius: 50%;
  background: #fff;
  color: #909399;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.file-remove-btn:hover {
  color: #f56c6c;
  border-color: #f56c6c;
}

.file-remove-btn i {
  font-size: 12px;
  line-height: 1;
}

/* 面试评价：与添加面试一致的白底弹窗，仅补充单选项与评语区 */
.eval-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 10px;
}

.eval-radio-group label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text);
  cursor: pointer;
}

/* 覆盖 InterviewerLayout 里 .modal-content input { width:100% }，避免单选被拉满一行 */
.modal-body .eval-radio-group input[type="radio"] {
  width: auto;
  margin-bottom: 0;
  padding: 0;
}

.eval-radio-group--error {
  border: 1px solid #f56c6c;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.modal-body .eval-textarea.field-error {
  border-color: #f56c6c !important;
}

/* 简历预览弹窗样式（与复核页保持一致） */
.preview-modal .modal-content {
  width: 1200px;
  max-width: 98vw;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
  background: #ffffff;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
}

.preview-header h3 {
  margin: 0;
  font-size: 18px;
}

.preview-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  background: #ffffff;
  position: relative;
  min-height: 200px;
}

.preview-body--word {
  background: #ffffff !important;
}

.preview-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  font-size: 14px;
  color: var(--muted);
}

.preview-iframe {
  width: 100%;
  height: 70vh;
  border: none;
  background: #f5f5f5;
}

.preview-body--word .preview-iframe {
  background: #ffffff;
}

.preview-body--word /deep/ .docx-wrapper {
  background: #ffffff !important;
}

.preview-body--word /deep/ .docx-wrapper .docx {
  border: none !important;
  box-shadow: none !important;
}

/* vue-office/pdf: 强制预览 wrapper 背景为淡灰色 */
.preview-iframe /deep/ .vue-office-pdf-wrapper {
  background: #f5f5f5 !important;
  padding: 0 !important;
}

/* vue-office/docx: 压缩容器留白并放大文档页可视宽度（不改弹框宽度） */
.preview-body /deep/ .vue-office-docx-wrapper,
.preview-body /deep/ .docx-wrapper {
  padding: 8px 10px !important;
}

.preview-body /deep/ .docx-wrapper > section,
.preview-body /deep/ .docx-wrapper .docx {
  width: calc(100% - 20px) !important;
  max-width: none !important;
  margin-left: auto !important;
  margin-right: auto !important;
  box-sizing: border-box !important;
}

.preview-body /deep/ .docx-wrapper > section {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.preview-footer {
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  text-align: right;
}

.preview-footer .el-button:first-child {
  margin-right: 8px;
}

.preview-footer .el-button + .el-button {
  margin-left: 10px;
}

.send-loading-mask {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-loading-card {
  min-width: 160px;
  padding: 18px 22px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.send-loading-spinner {
  width: 38px;
  height: 38px;
  border: 4px solid #dbeafe;
  border-top-color: #4270f1;
  border-radius: 50%;
  animation: send-loading-spin 0.8s linear infinite;
}

.send-loading-text {
  color: var(--muted);
  font-size: 14px;
  line-height: 1;
}

@keyframes send-loading-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .topbar {
    padding: 8px 0;
    margin-bottom: 0;
  }

  .topTitle {
    font-size: 16px;
  }

  .topRight {
    justify-content: flex-end;
  }

  .schedule-mobile {
    margin-top: 8px;
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .schedule-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-right: 2px;
  }

  .schedule-mobile-filter {
    background: #ffffff;
    border-radius: 12px;
    padding: 10px 12px;
    border: 1px solid var(--line);
    flex-shrink: 0;
  }

  .schedule-mobile-filter-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .schedule-card-empty {
    margin-top: 12px;
    font-size: 13px;
    color: var(--muted);
    text-align: center;
  }

  .schedule-mobile-load-more {
    margin: 4px 0 8px;
    font-size: 12px;
    color: #909399;
    text-align: center;
  }

  .schedule-mobile-load-more.done {
    color: #c0c4cc;
  }

  .schedule-mobile-loading-mask {
    margin-top: 10px;
  }

  .schedule-mobile-loading-mask /deep/ .el-skeleton__item {
    border-radius: 10px;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item__label {
    padding-bottom: 4px;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item__content {
    line-height: 1;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .schedule-mobile-filter-grid /deep/ .el-select .el-input__suffix {
    right: 6px;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__icon {
    line-height: 32px;
  }

  .schedule-mobile-filter-grid /deep/ .schedule-mobile-candidate-search-icon {
    cursor: pointer;
  }

  .schedule-mobile-filter-grid /deep/ .el-input--small .el-input__inner {
    padding-right: 28px;
  }

  .schedule-mobile-filter-grid /deep/ .el-select,
  .schedule-mobile-filter-grid /deep/ .el-input {
    width: 100%;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item__label,
  .schedule-mobile-filter-grid /deep/ .el-input__inner {
    font-size: 14px;
  }

  .schedule-mobile-filter-grid /deep/ .el-select .el-input .el-select__caret {
    font-size: 12px;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__inner::placeholder {
    font-size: 12px;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__clear {
    font-size: 12px;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__prefix,
  .schedule-mobile-filter-grid /deep/ .el-input__suffix {
    top: 0;
    display: inline-flex;
    align-items: center;
  }

  .schedule-mobile-filter-grid /deep/ .el-select-dropdown__item {
    font-size: 12px;
  }

  .schedule-mobile-filter-grid /deep/ .el-select .el-input.is-focus .el-input__inner {
    border-color: #4270f1;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__inner:focus {
    border-color: #4270f1;
  }

  .schedule-mobile-filter-grid /deep/ .el-select .el-input__inner,
  .schedule-mobile-filter-grid /deep/ .el-input__inner {
    border-radius: 8px;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item:last-child .el-form-item__content {
    margin-bottom: 0;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item:first-child .el-form-item__content {
    margin-bottom: 0;
  }

  .schedule-mobile-filter {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .schedule-mobile-filter + .schedule-card-list {
    margin-top: 10px;
  }

  .schedule-mobile-pagination {
    display: none;
  }

  .schedule-mobile {
    overflow: hidden;
  }

  .schedule-card-list::-webkit-scrollbar {
    width: 4px;
  }

  .schedule-card-list::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.35);
    border-radius: 999px;
  }

  .schedule-card-list::-webkit-scrollbar-track {
    background: transparent;
  }

  .schedule-card-list {
    padding-bottom: 8px;
  }

  .schedule-card-empty {
    padding: 24px 0;
  }

  .schedule-mobile-filter {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .schedule-mobile-filter-grid {
    align-items: end;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item__label {
    line-height: 18px;
  }

  .schedule-mobile-filter-grid /deep/ .el-input__inner {
    box-sizing: border-box;
  }

  .schedule-mobile-filter-grid /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .schedule-mobile-load-more,
  .schedule-card-empty {
    flex-shrink: 0;
  }

  .schedule-mobile-load-more {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .topCreateBtn--mobile {
    padding: 4px 10px;
    border-radius: 999px;
  }
}

/* 书签栏显示时视口高度小于 953px，收紧表格与分页区内边距 */
@media (max-height: 952px) {
  ::v-deep .table-loading-wrap{
    padding: 14px 16px 2px !important;
  }
  ::v-deep .pagination {
    padding: 10px 16px 6px !important;
  }
  ::v-deep .filter-grid {
    gap: 0 12px !important;
  }
  ::v-deep .search-bar{
    padding: 10px 16px 12px !important;
  }
}
</style>

